export enum RejectFlgEnum {
  Reject = '2',
}
